<template>
  <div class="col-12 col-md-3 left-menu mb-3">
    <CommunityCard class="pb-2" :withHorizontalRules="false">
      <div class="isim-community-card-header">
        <h5 class="m-0">TMS</h5>
      </div>
      <ul class="list-group">
        <router-link to="/tms">
          <li
            class="list-group-item d-flex align-items-center"
            v-bind:class="{ active: onScenarios }"
          >
            <img
              class="mr-2"
              width="24"
              height="24"
              :src="
                onScenarios
                  ? require('@/assets/nav-icons/my-scenarios-fill.svg')
                  : require('@/assets/nav-icons/my-scenarios.svg')
              "
              alt="icon"
            />
            Scenarios
          </li>
        </router-link>
        <router-link to="/tms/students">
          <li
            class="list-group-item d-flex align-items-center"
            v-bind:class="{ active: onStudents }"
          >
            <img
              class="mr-2"
              width="24"
              height="24"
              :src="
                onStudents
                  ? require('@/assets/nav-icons/my-profile-fill.svg')
                  : require('@/assets/nav-icons/my-profile.svg')
              "
              alt="icon"
            />
            Students
          </li>
        </router-link>
      </ul>
    </CommunityCard>
  </div>
</template>

<script>
import CommunityCard from "@/components/CommunityCard";

export default {
  name: "TmsMenu",
  components: {
    CommunityCard,
  },
  computed: {
    onScenarios() {
      return this.$route.path === "/tms";
    },
    onStudents() {
      return this.$route.path === "/tms/students";
    },
  },
};
</script>

<style scoped>
.list-group-item.active {
  color: var(--isim-primary);
}
@media (min-width: 992px) {
  .collapse.dont-collapse-sm {
    display: block;
    height: auto !important;
    visibility: visible;
  }

  .list-group-item a {
    color: #333;
  }
  .list-group-item {
    color: #212529;
  }
}

ul.list-group li:not(:first-child a):not(:last-child a) {
  border-radius: 0px;
}

ul.list-group li :first-child a {
  border-bottom-left-radius: 0px;
}

ul.list-group li:last-child a {
  border-top-left-radius: 0px;
}

.list-group-item {
  border: none;
  margin-bottom: 5px;
  color: var(--isim-light-text);
  margin-left: 0px;
  background: inherit;
  max-height: 2.2rem;
}
</style>
